import React, { useContext, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
    FiArrowRight,
    FiArrowLeft,
    FiLoader,
    FiZap,
} from 'react-icons/fi';
import {
    format,
    addMonths,
} from 'date-fns';
import Select from '../../components/ui/Select';
import apiUtils from '../../utils/apiutils';
import { toast } from 'sonner';

import { Link } from 'react-router-dom';
import { DatePicker, Tooltip } from 'antd';

import { DataContext } from 'context/DataContext';
import RenderBlock from './Calculator/RenderBlock';
import { calculatorCategories } from 'data/calculatorCategories';
import LoadingOverlay from 'components/ui/LoadingOverlay';
import { IoMdRocket } from 'react-icons/io';



const Calc = () => {
    const [activeCalculator, setActiveCalculator] = useState(null);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [calcResult, setCalcResult] = useState(null);
    const [calcResultTitle, setCalcResultTitle] = useState('');
    const [exchanges, setExchanges] = useState([]);
    const [selectedExchange, setSelectedExchange] = useState("");
    const [symbols, setSymbols] = useState([]);

    const {
        myexchanges,
        coins,
    } = useContext(DataContext);

    // Fetch exchanges
    const handegetExchanges = async () => {
        try {
            const resp = await apiUtils.post("/api/get_exchange_name", {
                showToast: false,
            });
            if (resp?.Success) setExchanges(resp.Success);
        } catch (e) {
            console.error("Error fetching exchanges:", e);
        }
    };

    // Fetch symbols
    const handegetSymbols = async (exchange) => {
        if (!exchange) return;
        // setIsLoadingSymbols(true);
        const payloads = {
            exchange: exchange,
            exchange_type: "futures",
        };
        try {
            const resp = await apiUtils.post("/api/get_exchange_symbols", payloads, {
                showToast: false,
            });
            if (resp?.Success?.Symbols) {
                setSymbols(resp.Success.Symbols);
            }
        } catch (e) {
            console.error("Error fetching symbols:", e);
        } finally {
            //   setIsLoadingSymbols(false);
        }
    };

    useEffect(() => {
        if (selectedExchange) {
            handegetSymbols(selectedExchange);   // fetch symbols
        } else {
            setSymbols([]);
        }
    }, [selectedExchange]);   // 👈 only watch selected exchange


    useEffect(() => {
        handegetExchanges();
    }, [])




    const handleCalculate = async (calculator) => {
        const data = formData[calculator.id] || {};
        const fields = calculator.fields;

        // Validate required fields
        for (const field of fields) {
            if (field.required && !data[field.name]) {
                toast.error(`${field.label || field.name} is required`);
                return; 
            }
        }

        if (calculator.id === 'liquidation_calc') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/liquidation_calculate',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    // setCalcResultTitle(calculator.name + ' Result');
                    setTimeout(() => {
                        const resultEl = document.getElementById('result-block');
                        if (resultEl) {
                            resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }, 100);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                // toast.error(error.response?.Error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'fee_calc') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/custom_exchange_fee_calculator',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'dca_basic') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/calculate_dca',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'historical_dca') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/calculate_historical_dca',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'dca_position') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/calculate_position_size',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'plc') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/pl_calculate',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'cryp') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/crypto_convert',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'staking_rewards') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/calculate_staking_rewards',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
        else if (calculator.id === 'holdingr') {
            try {
                setLoading(true);
                const jwt = localStorage.getItem('jwt');
                const response = await apiUtils.post(
                    '/calculator/calculate_holding_return',
                    { ...data },
                    { showToast: false }
                );

                if (response?.Success) {
                    // clear formdata after successful calculation
                    setFormData((prev) => ({
                        ...prev,
                        [calculator.id]: {},
                    }));

                    setCalcResult(response?.Success);
                    setCalcResultTitle(calculator.name + ' Result');
                    setShowModal(true);
                    setLoading(false);

                    // Clear form data
                    setFormData(prev => ({
                        ...prev,
                        [calculator.id]: {}
                    }));
                }
            } catch (error) {
                toast.error(error.response.data.Error)
                console.error('Error calculating fees:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const renderField = (field, calcId) => {
        const value = formData[calcId]?.[field.name] || '';
        const isNumber = field.type === 'number';
        const isLeverage = field.name === 'leverage';

        // Prevent negative numbers
        const handleInputChange = (calcId, fieldName, value) => {


            if (isNumber && value < 0) {
                return; // Prevent negative numbers
            }

            if (isLeverage && (value > 100)) return;

            setFormData(prev => ({
                ...prev,
                [calcId]: {
                    ...prev[calcId],
                    [fieldName]: value
                }
            }));
        };


        if (field.name === 'exchange') {

            const exchangeOptions = exchanges

                .map((ex) => ({
                    value: ex,
                    searchableText: ex,
                    label: (
                        <div className="flex items-center gap-2">
                            <span>{ex.toUpperCase()}</span>
                        </div>
                    ),
                }));

            return (
                <Select
                    options={exchangeOptions}
                    value={value}
                    onChange={(val) => {
                        handleInputChange(calcId, field.name, val);
                        setSelectedExchange(val);
                    }}
                    placeholder="Select Exchange"
                    type="exchange"
                />
            );
        }

        if (field.name === 'symbol') {
            const value = formData[calcId]?.symbol || '';
          
            const coinOptions = symbols.map((c) => {
              const base = c.replace("USDT", "");
          
              return {
                value: base,
                searchableText: base,
                label:c,
                dropdownLabel: (
                  <div className="flex items-center gap-2">
                    <span>{base}</span>
                  </div>
                ),
              };
            });
          
            return (
              <Select
                options={coinOptions}
                value={value}
                onChange={(val) => handleInputChange(calcId, field.name, val)}
                placeholder="Select Coin"
                type="coin"
              />
            );
          }
          

        if (field.name === 'from_symbol') {

            const value = formData[calcId]?.from_symbol || '';
            console.log(value, 'from_symbol');


            const coinOptions = coins.map((coin) => ({
                value: coin.symbol,
                searchableText: coin.name + ' ' + coin.symbol,
                label: (
                    <div className="flex items-center gap-2">
                        <img src={coin.image} alt={coin.symbol} className="w-5 h-5 rounded-full" />
                        <span>{coin.symbol}</span>
                    </div>
                ),
            }));

            return (
                <Select
                    options={coinOptions}
                    value={value}
                    onChange={(val) => handleInputChange(calcId, field.name, val)}
                    placeholder="Select Coin"
                    type="coin"
                />
            );
        }
        if (field.name === 'to_symbol') {

            const value = formData[calcId]?.to_symbol || '';

            const coinOptions = coins.map((coin) => ({
                value: coin.symbol,
                searchableText: coin.name + ' ' + coin.symbol,
                label: (
                    <div className="flex items-center gap-2">
                        <img src={coin.image} alt={coin.symbol} className="w-5 h-5 rounded-full" />
                        <span>{coin.symbol}</span>
                    </div>
                ),
            }));

            return (
                <Select
                    options={coinOptions}
                    value={value}
                    onChange={(val) => handleInputChange(calcId, field.name, val)}
                    placeholder="Select Coin"
                    type="coin"
                />
            );
        }

        if (field.type === 'select') {
            const options = field.options || [];

            return (
                <Select
                    // label={field.label}  
                    options={options.map((opt) => ({
                        value: opt,
                        searchableText: opt,
                        label: (
                            <span className="flex items-center gap-2 uppercase">
                                {opt}
                            </span>
                        ),
                    }))}
                    value={value}
                    onChange={(val) => handleInputChange(calcId, field.name, val)}
                    placeholder={field.placeholder || `Select ${field.label}`}
                />
            );
        }

        if (field.type === 'textarea') {
            return (
                <motion.textarea
                    className="w-full px-4 py-3 bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-xl text-white placeholder-slate-400 resize-none focus:outline-none focus:border-blue-400/50 transition-all duration-300"
                    rows={4}
                    placeholder={field.placeholder}
                    value={value}
                    onChange={(e) => handleInputChange(calcId, field.name, e.target.value)}
                    whileFocus={{ scale: 1.01 }}
                />
            );
        }


        if (field.type === 'date') {

            const defaultDate = format(addMonths(new Date(), -1), 'yyyy-MM-dd');
            const fieldValue = formData?.[calcId]?.[field.name];

            // Set default only once on mount if not set
            if (!fieldValue) {
                setFormData(prev => ({
                    ...prev,
                    [calcId]: {
                        ...prev[calcId],
                        [field.name]: defaultDate
                    }
                }));
            }

            return (
                <DatePicker
                    // label={field.label}
                    value={value}
                    onChange={(val) => handleInputChange(calcId, field.name, val)}
                    defaultDate={defaultDate}
                    minDate={field.minDate}
                    maxDate={field.maxDate}
                    disableFuture={field.disableFuture}
                    disablePast={field.disablePast}
                    placeholder={field.placeholder || `Select ${field.label}`}
                // error={formErrors?.[calcId]?.[field.name]}
                />
            );
        }




        return (
            <motion.input
                type={field.type}
                className="w-full px-4 py-3 bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-xl text-white placeholder-slate-400 focus:outline-none focus:border-blue-400/50 transition-all duration-300"
                placeholder={field.placeholder}
                value={value}
                onChange={(e) => handleInputChange(calcId, field.name, e.target.value)}
                whileFocus={{ scale: 1.01 }}
            />
        );
    };

    //   const { isLocked } = useLock();
    //   if (isLocked("Quant_Tools")) {
    //       return (
    //         <div className="flex flex-col items-center justify-center h-full p-6 text-center">
    //           <FaLock className="text-5xl text-red-500 mb-4" />
    //           <h2 className="text-xl font-semibold">Access Locked</h2>
    //           <p className="text-gray-400 mt-2">
    //             This feature is not available in your plan.
    //           </p>
    //         </div>
    //       );
    //     }

    return (
        <div className="min-h-screen relative overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl animate-pulse"></div>
            </div>

            <div className="relative z-10  mx-auto px-4 sm:px-6 lg:px-8 py-4">
                {/* Header */}
                {/* <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center gap-2 text-primary">
            <BsCalculator className="text-lg animate-pulse text-blue-400" />
          </div>
          <h1 className="text-3xl font-bold">Trading Calculators</h1>
          <div className="ml-auto flex items-center gap-2 text-muted-foreground text-sm">

          </div>
        </div> */}

                {/* Calculator Categories */}
                {!activeCalculator ? (
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
                        {calculatorCategories.map((category, index) => (
                            <Link to={category.link}>
                                <motion.div
                                    key={category.id}
                                    initial={{ opacity: 0, y: 50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1, duration: 0.6 }}
                                    className="group cursor-pointer"
                                    onClick={() => setActiveCalculator(category.id)}
                                >
                                    <motion.div
                                        className={`relative p-2 rounded-2xl h-[180px] bg-slate-800/50 backdrop-blur-md border border-slate-700/50 hover:border-slate-600/50 transition-all duration-500 overflow-hidden ${category.bgColor}`}
                                        whileHover={{ scale: 1.02, y: -5 }}
                                        whileTap={{ scale: 0.98 }}
                                    >
                                        {/* Gradient overlay */}
                                        <div className={`absolute inset-0 bg-gradient-to-br ${category.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>

                                        <div className="relative z-10">
                                            <div className="flex items-center justify-between mb-6">
                                                <motion.div
                                                    className={`p-4 rounded-xl bg-gradient-to-br ${category.color} shadow-lg`}
                                                    whileHover={{ rotate: 360 }}
                                                    transition={{ duration: 0.8 }}
                                                >

                                                    <category.icon className="w-4 h-4 text-white" />
                                                </motion.div>

                                                <motion.div
                                                    className="text-slate-400 group-hover:text-white transition-colors duration-300"
                                                    whileHover={{ x: 5 }}
                                                >

                                                    <FiArrowRight className="w-6 h-6" />
                                                    {/* </Link> */}
                                                </motion.div>
                                            </div>

                                            <h3 className="text-md font-bold text-white mb-3 group-hover:text-white transition-colors duration-300">
                                                {category.title}
                                            </h3>

                                            <p className="text-slate-300 leading-relaxed group-hover:text-slate-200 transition-colors duration-300">
                                                {category.description1}
                                            </p>
                                        </div>

                                    </motion.div>

                                </motion.div>
                            </Link>
                        ))}
                    </div>
                ) : (
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeCalculator}
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -50 }}
                            transition={{ duration: 0.5 }}
                            className="space-y-8"
                        >
                            <div className="flex items-center justify-between mb-8">
                                <motion.button
                                    onClick={() => {
                                        setActiveCalculator(null);
                                        setCalcResult(null);
                                    }}
                                    className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors duration-300"
                                    whileHover={{ x: -5 }}
                                >
                                    <FiArrowLeft className="w-5 h-5" />
                                    <span>Back to Categories</span>
                                </motion.button>
                            </div>

                            {calculatorCategories
                                .filter(cat => cat.id === activeCalculator)
                                .map(category => (
                                    <div key={category.id} className="space-y-8">
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.6 }}
                                            className="flex flex-col p-6 rounded-2xl shadow-2xl   from-indigo-600/70 via-purple-700/60 to-pink-600/60 backdrop-blur-lg border border-white/20"
                                        >
                                            <div className='flex justify-between'>
                                                <h2 className="text-xl font-bold text-slate-400 mb-4 tracking-tight" style={{ fontFamily: '"Space Mono", monospace' }}>
                                                    {category.title}
                                                </h2>

                                                {/* <Link target='_blank' to={category?.guide}> <span className='flex items-center gap-2 bg-logiculustheme-neonBlue px-3 py-1 rounded-xl'>Guide<FaBook size={15} /></span> </Link> */}

                                            </div>
                                            {/* Description */}
                                            <div className=" flex  items-center">
                                                {Array.isArray(category.description) &&
                                                    category.description.map((point, index) => (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 10 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ delay: 0.3 + index * 0.1, duration: 0.5 }}
                                                        >
                                                            <p className="text-white  text-sm  leading-relaxed" style={{ fontFamily: '"Space Mono", monospace' }}>
                                                                {point}
                                                            </p>
                                                        </motion.div>
                                                    ))}
                                            </div>
                                        </motion.div>
                                        <div
                                            className={`transition-all duration-500 ${loading || (activeCalculator && calcResult)
                                                ? 'grid grid-cols-1 lg:grid-cols-4 gap-5'
                                                : 'flex justify-center items-center'
                                                }`}
                                        >
                                            {/* FORM COLUMN */}
                                            <AnimatePresence mode="wait">
                                                <motion.div
                                                    key={loading || (activeCalculator && calcResult) ? 'left-slide' : 'centered'}
                                                    // initial={{ x: 0, opacity: 0 }}
                                                    // animate={{ x: 0, opacity: 1 }}
                                                    // exit={{ x: -50, opacity: 0 }}
                                                    transition={{ duration: 0.5 }}
                                                    className={`transition-all duration-500 px-4 sm:px-6 ${loading || (activeCalculator && calcResult)
                                                        ? 'lg:col-span-1'
                                                        : 'flex justify-center items-center'
                                                        }`}
                                                >
                                                    <div className={loading || (activeCalculator && calcResult) ? 'w-full' : 'lg:w-[500px] h-[580px] mx-auto'}>
                                                        {Array.isArray(category.calculators) && category.calculators.map((calculator, calcIndex) => (
                                                            <motion.div
                                                                key={calculator.id}
                                                                initial={{ opacity: 0, y: 30 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ delay: calcIndex * 0.1, duration: 0.6 }}
                                                                className="bg-slate-800/50    backdrop-blur-md rounded-2xl p-8 border border-slate-700/50 shadow-2xl"
                                                            >
                                                                <form
                                                                    onSubmit={(e) => {
                                                                        e.preventDefault();
                                                                        // handleCalculate(calculator);
                                                                    }}
                                                                    className="space-y-2"
                                                                >
                                                                    {calculator.fields.map((field, fieldIndex) => (
                                                                        <motion.div
                                                                            key={field.name}
                                                                            initial={{ opacity: 0, x: -20 }}
                                                                            animate={{ opacity: 1, x: 0 }}
                                                                            transition={{ delay: fieldIndex * 0.1, duration: 0.5 }}
                                                                            className="space-y-2"
                                                                        >

                                                                            <label
                                                                                style={{ fontFamily: '"Space Mono", monospace' }}
                                                                                className="block text-sm   font-semibold text-slate-300 mb-2"
                                                                            >
                                                                                <Tooltip title={field.tooltip}> <span className=' border-b border-dashed border-white'>{field.label}</span></Tooltip>

                                                                            </label>

                                                                            {renderField(field, calculator.id)}
                                                                        </motion.div>
                                                                    ))}

                                                                    <motion.button
                                                                        // type="submit"
                                                                        onClick={() => handleCalculate(calculator)}
                                                                        disabled={loading}
                                                                        className={`w-full py-4 px-6 rounded-xl font-bold text-white transition-all duration-300 ${loading
                                                                            ? 'bg-slate-600 cursor-not-allowed'
                                                                            : `bg-gradient-to-r ${category.color} hover:shadow-2xl hover:shadow-blue-500/25`
                                                                            }`}
                                                                        whileHover={{ scale: loading ? 1 : 1.02 }}
                                                                        whileTap={{ scale: loading ? 1 : 0.98 }}
                                                                    >
                                                                        <div className="flex items-center justify-center gap-3">
                                                                            {loading ? (
                                                                                <>
                                                                                    <motion.div
                                                                                        animate={{ rotate: 360 }}
                                                                                        transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
                                                                                    >
                                                                                        <FiLoader className="w-5 h-5" />
                                                                                    </motion.div>
                                                                                    <span>Calculating...</span>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <FiZap className="w-5 h-5" />
                                                                                    <span>Calculate Now</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </motion.button>
                                                                </form>
                                                            </motion.div>
                                                        ))}
                                                    </div>
                                                </motion.div>
                                            </AnimatePresence>

                                            {/* RESULT COLUMN */}
                                            <AnimatePresence>
                                                {loading || (activeCalculator && calcResult) ? (
                                                    <motion.div
                                                        key="result-panel"
                                                        initial={{ x: 100, opacity: 0 }}
                                                        animate={{ x: 0, opacity: 1 }}
                                                        exit={{ x: 100, opacity: 0 }}
                                                        transition={{ duration: 0.5 }}
                                                        className="lg:col-span-3"
                                                    >
                                                        {loading ? (
                                                            <LoadingOverlay
                                                                visible={loading}
                                                                icon={IoMdRocket}
                                                                message="Running Calculator..."
                                                                subtext="Analyzing calculator results..."
                                                            />
                                                        ) : (
                                                            <RenderBlock calculatorId={activeCalculator} result={calcResult} />
                                                        )}
                                                    </motion.div>
                                                ) : null}
                                            </AnimatePresence>
                                        </div>


                                    </div>
                                ))}
                        </motion.div>
                    </AnimatePresence>
                )}

            </div>
        </div>
    );
};

export default Calc;